import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Заявка отправлена!',
  subtitle: 'Ожидайте звонка от нашего финансового менеджера в течение часа',
} as const satisfies TMessages
